module.exports = __webpack_public_path__ + "static/media/Cindy_Ayres_Foot_Print.6320adff.jpg";